import type React from 'react';

import type { Props as InputProps } from '../Input/Input';
import Input from '../Input/Input';

interface NumberInputProps extends InputProps {
  min?: number;
  max?: number;
  step?: number;
}

const Numbers: React.FC<NumberInputProps> = (props) => <Input {...props} type="number" />;

export default Numbers;
